var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.Publisher.SelectedPublisher)?_c('img',{staticClass:"publisher-logo",attrs:{"src":_vm.Publisher.getLogoUrl(_vm.Publisher.SelectedPublisher),"alt":_vm.Publisher.SelectedPublisher.title}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }